export default __webpack_public_path__ + "static/17-080bffeb5ea872016a18267b5b466635.png";